import { call, put } from 'redux-saga/effects';

import { saveWorkflowDraft, sendTestTrigger } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import { WorkflowType } from '../../enums';
import { parseWorkflowForSaving } from '../../utils';
import { SendTestTriggerRequestAction, actions } from '../actions';

export default function* sendTestTriggerSaga(action: SendTestTriggerRequestAction) {
  const message = `Error sending test trigger. Please try again later.`;
  try {
    yield put(actions.updateIsAsyncLoading(true));
    const { dataFields, email, userId, overrideSendLimit, triggerNode, workflow } = action.payload;

    const updatedWorkflow = parseWorkflowForSaving(workflow);
    const { data, errors } =
      workflow.workflowType === WorkflowType.DRAFT
        ? yield call(saveWorkflowDraft, updatedWorkflow)
        : { data: { saveWorkflowDraft: { id: workflow.id } }, errors: [] };

    if (errors?.length) {
      throw errors;
    }

    const workflowId = data?.saveWorkflowDraft?.id;

    if (!workflowId) {
      yield put(addNegativeToastWithErrorId(message, 'sendTestTriggerSaga'));
    } else {
      yield call(
        sendTestTrigger as any,
        dataFields,
        email,
        userId,
        overrideSendLimit,
        triggerNode,
        workflowId,
        updatedWorkflow,
      );
      yield put(addPositiveToast('Test journey started!'));
    }
    yield put(actions.updateIsAsyncLoading(false));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.sendTestTriggerError(err));
    yield put(addNegativeToastWithErrorId(message, 'sendTestTriggerSaga'));
    yield put(actions.updateIsAsyncLoading(false));
  }
}
